import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main_table_box" }
const _hoisted_2 = { class: "table_wrapper" }
const _hoisted_3 = { class: "sort_table table tablesorter" }
const _hoisted_4 = { class: "thead-light" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"75px"},
  class: /*#__PURE__*/_normalizeClass({ sorter: false })
}, null, -1)
const _hoisted_6 = { style: {"width":"100px"} }
const _hoisted_7 = {
  key: 0,
  style: {"width":"175px"}
}
const _hoisted_8 = { style: {"width":"250px"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { style: {"width":"75px"} }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { style: {"width":"100px"} }
const _hoisted_13 = { class: "table_date" }
const _hoisted_14 = {
  key: 0,
  style: {"width":"175px"}
}
const _hoisted_15 = { class: "desc" }
const _hoisted_16 = { class: "destination" }
const _hoisted_17 = {
  key: 0,
  class: "destination"
}
const _hoisted_18 = { class: "desc" }
const _hoisted_19 = { class: "destination" }
const _hoisted_20 = {
  key: 1,
  class: "destination"
}
const _hoisted_21 = {
  key: 2,
  class: "destination"
}
const _hoisted_22 = {
  key: 1,
  style: {"width":"250px"}
}
const _hoisted_23 = { class: "explanation" }
const _hoisted_24 = { class: "balance_sum" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tablesort = _resolveDirective("tablesort")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$localization.getTranslate("Date")), 1),
            (_ctx.type == 'Account')
              ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.$localization.getTranslate("Recipient")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$localization.getTranslate("PurposePayment")), 1),
            (_ctx.type == 'Account')
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_ctx.$localization.getTranslate("Explanation")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", null, _toDisplayString(_ctx.$localization.getTranslate("Amount")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.FormatDateString(new Date(transaction.DateCreateJs))), 1)
                ])
              ]),
              (_ctx.type == 'Account')
                ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$localization.getTranslate("Payer")) + ":", 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(transaction.FromName), 1)
                    ]),
                    (
									transaction.FromCardNumber != null && transaction.FromCardNumber !== ''
								)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", null, "ABA" + _toDisplayString(transaction.FromCardNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$localization.getTranslate("Beneficiary")) + ":", 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(transaction.ToName), 1)
                    ]),
                    (transaction.ToCardNumber != null && transaction.ToCardNumber !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("span", null, "ABA" + _toDisplayString(transaction.ToCardNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (transaction.IBAN !== '' && transaction.IBAN != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString(transaction.IBAN), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.type == 'Account')
                ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(transaction.PurposeOfPayment), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(transaction.TypeTransactionName) + _toDisplayString(_ctx.translateTypeTransaction(
											transaction.TypeTransactionId,
											transaction.TypeTransactionName
										)), 1)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
										minus: transaction.Amount < 0,
										plus: transaction.Amount > 0,
									})
                  }, _toDisplayString(transaction.Amount) + " " + _toDisplayString(transaction.CurrencyName), 3)
                ])
              ])
            ]))
          }), 128))
        ])
      ])), [
        [_directive_tablesort]
      ])
    ])
  ]))
}